/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A lender a terms version introduces the resident to, in order (TXN-3383).
 * 
 * `mortgage_credit` is the lender's credit toward points to buy down the rate, in whole dollars (TXN-3526);
 * `mortgage_credit_applies` is false when the credit is zero, or the lender gives it only as the sole lender
 * introduced and the version introduces more than one.
 * @export
 * @interface HomeownershipTermsLender
 */
export interface HomeownershipTermsLender {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsLender
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsLender
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsLender
     */
    mode?: HomeownershipTermsLenderModeEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsLender
     */
    connection?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsLender
     */
    connectionName?: string;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipTermsLender
     */
    mortgageCredit: number;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipTermsLender
     */
    discountRequiresExclusive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipTermsLender
     */
    mortgageCreditApplies: boolean;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsLender
     */
    consentText?: string;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipTermsLender
     */
    consentVersion?: number;
}


/**
 * @export
 */
export const HomeownershipTermsLenderModeEnum = {
    Link: 'link',
    Api: 'api'
} as const;
export type HomeownershipTermsLenderModeEnum = typeof HomeownershipTermsLenderModeEnum[keyof typeof HomeownershipTermsLenderModeEnum];


/**
 * Check if a given object implements the HomeownershipTermsLender interface.
 */
export function instanceOfHomeownershipTermsLender(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "mortgageCredit" in value;
    isInstance = isInstance && "discountRequiresExclusive" in value;
    isInstance = isInstance && "mortgageCreditApplies" in value;

    return isInstance;
}

export function HomeownershipTermsLenderFromJSON(json: any): HomeownershipTermsLender {
    return HomeownershipTermsLenderFromJSONTyped(json, false);
}

export function HomeownershipTermsLenderFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipTermsLender {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'link': !exists(json, 'link') ? undefined : json['link'],
        'mode': !exists(json, 'mode') ? undefined : json['mode'],
        'connection': !exists(json, 'connection') ? undefined : json['connection'],
        'connectionName': !exists(json, 'connection_name') ? undefined : json['connection_name'],
        'mortgageCredit': json['mortgage_credit'],
        'discountRequiresExclusive': json['discount_requires_exclusive'],
        'mortgageCreditApplies': json['mortgage_credit_applies'],
        'consentText': !exists(json, 'consent_text') ? undefined : json['consent_text'],
        'consentVersion': !exists(json, 'consent_version') ? undefined : json['consent_version'],
    };
}

export function HomeownershipTermsLenderToJSON(value?: HomeownershipTermsLender | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'link': value.link,
        'mode': value.mode,
        'connection': value.connection,
        'connection_name': value.connectionName,
        'mortgage_credit': value.mortgageCredit,
        'discount_requires_exclusive': value.discountRequiresExclusive,
        'mortgage_credit_applies': value.mortgageCreditApplies,
        'consent_text': value.consentText,
        'consent_version': value.consentVersion,
    };
}

